import { render, staticRenderFns } from "./PageMain.vue?vue&type=template&id=ec675be6&scoped=true&"
import script from "./PageMain.vue?vue&type=script&lang=js&"
export * from "./PageMain.vue?vue&type=script&lang=js&"
import style0 from "./PageMain.vue?vue&type=style&index=0&id=ec675be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec675be6",
  null
  
)

export default component.exports